const contentType = [
    { key: "TEXT", value: "Text" },
    { key: "VIDEO", value: "Spotify Link" },
    { key: "AUDIO", value: "Youtube Media" },
];

export { contentType };